// src/graphql/mutations/salesMutations.js
// Sales cockpit: import call lists, edit prospects, one-click teaser mail

export const importSalesProspects = `mutation ImportSalesProspects($input: ImportSalesProspectsInput!) {
    importSalesProspects(input: $input) {
        success
        created
        skipped
        skippedNames
        error
    }
}`;

export const updateSalesProspect = `mutation UpdateSalesProspect($id: String!, $input: UpdateSalesProspectInput!) {
    updateSalesProspect(id: $id, input: $input) {
        success
        error
        prospect {
            id
            status
            notes
            nextFollowUpAt
            contactEmail
        }
    }
}`;

export const deleteSalesProspect = `mutation DeleteSalesProspect($id: String!) {
    deleteSalesProspect(id: $id) {
        success
        error
    }
}`;

export const generateSalesProspectProfile = `mutation GenerateSalesProspectProfile($id: String!, $description: String) {
    generateSalesProspectProfile(id: $id, description: $description) {
        success
        error
        mustTerms
        optionalTerms
        cpvCodes
        nutsCodes
        websiteUrl
        prospect {
            id
            website
            searchProfile {
                query
                cpvCode
                nutsCodePrefix
                contractNatures
            }
        }
    }
}`;

export const sendSalesTeaser = `mutation SendSalesTeaser($input: SendSalesTeaserInput!) {
    sendSalesTeaser(input: $input) {
        success
        error
        email {
            id
            recipient
            subject
            status
            error
            tenderIds
            createdAt
        }
    }
}`;

export const crmLogCall = `mutation CrmLogCall($input: CrmLogCallInput!) {
    crmLogCall(input: $input) {
        id
        name
        phone
        city
        state
        region
        address
        prio
        status
        source
        categories
        size
        employees
        domains
        description
        notes
        followUpAt
        lastCallAt
        lat
        lng
        people { id name jobTitle }
    }
}`;

export const crmGeocodeCompanies = `mutation CrmGeocodeCompanies($limit: Int) {
    crmGeocodeCompanies(limit: $limit) {
        geocoded
        failed
        remaining
    }
}`;


// Cockpit door of the booking engine: book a Profil-Check on behalf of the
// prospect while they are on the phone. The backend sends both mails, flips
// the prospect pipeline and mirrors Status/Termin into the CRM.
export const adminBookMeeting = `mutation AdminBookMeeting($input: AdminBookMeetingInput!) {
    adminBookMeeting(input: $input) {
        success
        error
        meeting {
            token
            kind
            kindLabel
            status
            startAt
            endAt
            name
            companyName
            joinUrl
        }
    }
}`;


// The onboarding trigger: mails the hello.bidlyzer.com invitation (one
// button + the phone-friendly code) to a prospect.
export const sendSalesHelloInvite = `mutation SendSalesHelloInvite($input: SendSalesHelloInviteInput!) {
    sendSalesHelloInvite(input: $input) {
        success
        error
        email {
            id
            recipient
            subject
            status
            error
            createdAt
        }
    }
}`;
